<div class="jobcard-label" [ngStyle]="{color: labelColor ? labelColor : '', 'opacity': disabled ? '0.5' : '1'}">{{ label
  }}</div>
<div class="p-inputgroup">
  <span *ngIf="icon" class="input-icon" [ngStyle]="{'opacity': disabled ? '0.5' : '1'}">
    <daz-icon [color]="iconColor" [name]="icon" [size]="'20px'"></daz-icon>
  </span>

  <p-dropdown *ngIf="formatList.length === 0" #dropDownRef (onChange)="handleDataChange($event)" (onBlur)="onTouched()" [(ngModel)]="value"
              [disabled]="disabled" [ngClass]="{'hub-calendar-icon' : icon }" [optionLabel]="optionLabel" [options]="options"
              [placeholder]="placeholder" />

  <p-dropdown *ngIf="formatList.length > 0" #dropDownRef (onChange)="handleDataChange($event)" (onBlur)="onTouched()" [(ngModel)]="value"
              [disabled]="disabled" [ngClass]="{'hub-calendar-icon' : icon }" [optionLabel]="optionLabel" [options]="formatList"
              [placeholder]="placeholder" [optionValue]="optionValue">

    <ng-template pTemplate="value" let-value>
      <div class="flex align-items-center gap-2">
        <span [style.color]="value?.itemCount ==0 ? 'var(--iso-green-700)' : null">
          {{ value?.label }}
        </span>
      </div>
    </ng-template>

  </p-dropdown>

</div>
